module.exports = __webpack_public_path__ + "media/images/icon/user-verification-0c208d963f6c0d9d62686890a430c624.svg";